import { createCustomRouter, RouteConfig } from './custom-router';

const routes: RouteConfig[] = [

  {
    path: '/',
    // redirect: '/viewer'
    name: 'ModelList',
    component: () => import('../pages/ModelList.vue'),
    meta: { title: 'Web Wide World' },
  },
  {
    path: '/v2',
    // redirect: '/viewer'
    name: 'ModelListV2',
    component: () => import('../pages/ModelListV2.vue'),
    meta: { title: 'Web Wide World' },
  },
  {
    path: '/model',
    name: 'ModelDetail',
    component: () => import('../pages/ModelDetail.vue'),
    props: true,
  },
  {
    path: '/simple-viewer',
    name: 'ChunkedLoading',
    component: () => import('../pages/ChunkedLoading.vue'),
    props: true,
  },
  {
    path: '/viewer',
    name: 'Viewer',
    component: () => import('../pages/Metaverse.vue'),
    props: true,
  },
  {
    path: '/spark',
    name: 'spark',
    component: () => import('../pages/Spark.vue'),
    props: true,
  },
  {
    path: '/viewer2',
    name: 'viewer2',
    component: () => import('../pages/scene-viewer/SceneViewer.vue'),
    props: true,
  },
  {
    path: '/metaverse-interaction',
    name: 'MetaverseInteraction',
    component: () => import('../pages/Metaverse.vue'),
    props: true,
  },
  {
    path: '/test-gp/spark',
    name: 'TestGPSpark',
    component: () => import('../pages/test-gp/Spark.vue'),
    props: true,
  },
  {
    path: '/test-gp/mkkellogg',
    name: 'TestMkkellogg',
    component: () => import('../pages/test-gp/Mkkellogg.vue'),
    props: true,
  },
];

const router = createCustomRouter(routes);

// 导出路由组件
export { default as RouterView } from './RouterView.vue';
export { default as RouterLink } from './RouterLink.vue';

export default router;


